/**
 * This file is created to put app level constants, which would be used across app like domain url, http methods, env mode etc
 */
export default {
    httpMethod:{
        GET:'GET',
        POST:'POST',
        PUT:'PUT',
        DELETE:'DELETE'
    },
    mockAPIDomain:'http://example.com',
    ENV_PROD:'production',
    ENV_DEV:'development',
    contenType:{
        json:'application/json',
        formUrlEncoded:'application/x-www-form-urlencoded'
    }
}